const urls = {
  ui: {
    learnMore: () =>
      `https://support.atlassian.com/organization-administration/docs/learn-about-atlassian-intelligence/`,
    trustCenter: () => `https://www.atlassian.com/trust/atlassian-intelligence`,
    acceptableUsePolicy: () =>
      `https://www.atlassian.com/legal/acceptable-use-policy`,
    specificToS: () => `https://www.atlassian.com/legal/ai-terms`,
    otherProducts: () =>
      'https://support.atlassian.com/organization-administration/docs/activate-atlassian-intelligence-for-products/',
    whatIsAtlassianIntelligence: () =>
      'https://support.atlassian.com/bitbucket-cloud/docs/use-atlassian-intelligence-to-help-write-or-edit-content/',
    agenticPipelinesBetaRegistration: () =>
      'https://rovodevagents.atlassian.net/servicedesk/customer/portal/34',
  },
};

// eslint-disable-next-line import/no-default-export
export default urls;
